module.exports = __webpack_public_path__ + "img/road-event.1fd6f40b.svg";